<template>
  <BaseButtonElement
    v-bind="$props"
    :is-loading="isSubscribing"
    loading-spinner-position="inside"
    :handle-custom-click="handleSubscribeClick"
  />
</template>

<script>
import { mapState } from "pinia";
import {
  SubscribeToNewsletterElementMixin,
} from "%/dynamic-component-editor/standard-components/subscribe-to-newsletter/subscribe-to-newsletter-element-mixin";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import { useNewsletterStore } from "~/stores/newsletter-store";

export default {
  name: "SubscribeToNewsLetterButton",
  components: { BaseButtonElement },
  elementPanelSettings: {
    displayName: "Subscribe",
    elementGroup: "subscribeToNewsletterElements",
  },
  extends: BaseButtonElement,
  mixins: [SubscribeToNewsletterElementMixin],
  computed: {
    ...mapState(useNewsletterStore, ["loadingSubscribeToEmail"]),
    isSubscribing() {
      return this.loadingSubscribeToEmail;
    },
  },
  methods: {
    handleSubscribeClick() {
      useNewsletterStore().subscribeToEmail();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
